import React from 'react';

const Collapse = props => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45.22 44.03"
    {...props}
  >
    <defs>
      <style>
        {
          '.cls-1{fill:none;stroke:#231f20;stroke-miterlimit:10;stroke-width:3px}'
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <rect
        x={1.5}
        y={1.5}
        width={42.22}
        height={41.03}
        rx={4}
        ry={4}
        style={{
          fill: '#fff',
        }}
      />
      <rect
        className="cls-1"
        x={1.5}
        y={1.5}
        width={42.22}
        height={41.03}
        rx={4}
        ry={4}
      />
      <path
        className="cls-1"
        d="M13.08 1.5v42.52M30.14 15.38l-7.06 7.51M30.54 28.35l-7.6-7.6"
      />
    </g>
  </svg>
);

export default Collapse;
